<template>
  <div class="the-breadcrumb" v-if="showBreadcrumb">
    <div v-for="(item, idx) in items" :key="idx">
      <router-link v-if="item.to && (item.to.params || (item.to.name ? item.to.name : item.to) != $route.name)" :to="item.to">{{item.label}}</router-link>
      <span v-else>{{ item.label }}</span>

      <img
        v-if="idx + 1 < items.length"
        class="inline the-breadcrumb__chevron transform -rotate-90 mx-4"
        src="@/assets/images/arrow-down-white-icon.svg"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    showBreadcrumb() {
      return this.visible || (this.$route.meta && this.$route.meta.breadcrumb ? this.$route.meta.breadcrumb.parent : false)
    },
    items() {
      if (!this.$route.meta || !this.$route.meta.breadcrumb)
        return []

      const breadcrumb = this.$route.meta.breadcrumb
      
      let items = []

      // Check if the current component as dynamic breadcrumbs
      if (this.$route.matched && this.$route.matched.length > 0 && this.$route.matched[0].instances.default.breadcrumbs) {
        const breadcrumbs = this.$route.matched[0].instances.default.breadcrumbs

        for (var i = 0; i < breadcrumbs.length; i++) {
          items.push(breadcrumbs[i])
        }
      } else {
        items.push(breadcrumb)
      }

      // Add parents if needed
      while (items.length > 0 && items[0].parent) {
        const route = this.$router.options.routes.find((route) => {
          return (route.name == items[0].parent)
        })

        if (route && route.meta && route.meta.breadcrumb) {
          items.unshift(route.meta.breadcrumb)
        }
      }

      return items
    },
  },
}
</script>

<style lang="scss" scoped>
.the-breadcrumb {
  @apply h-10;
  position: absolute;
  top: 0px;
  background-color: rgba(38, 55, 70, 0.4);
  backdrop-filter: blur(4px);
  @apply text-white z-20 w-full flex items-center px-4 font-light;

  &__chevron {
    height: 0.3rem;
  }
}
</style>